import client, { appClient } from 'lib/api/client';
import { AUTH_BASIC } from 'lib/constant/api';

export const login = (username, password) =>
  client.post(
    `/auth/login`,
    { userId: username, password },
    {
      headers: {
        Authorization: `${AUTH_BASIC}`,
      },
    },
  );

export const logout = (accessToken, refreshToken) =>
  client.post(
    `/auth/revoke`,
    { accessToken, refreshToken },
    {
      headers: {
        Authorization: `${AUTH_BASIC}`,
      },
    },
  );

export const loginCheck = refreshToken =>
  client.post(
    `/auth/refresh`,
    { refreshToken },
    {
      headers: {
        Authorization: `${AUTH_BASIC}`,
      },
    },
  );

export const findId = ({ name, tel }) =>
  appClient.post(
    '/user/find',
    { name, tel },
    {
      headers: {
        Authorization: `Basic YTQ5YjRhOTYtYmViMi00MjQxLWE1NTQtMTI1Y2YyOTQ2OWE4OjMyWlhiMnBmdldEellOZ3pRd2ltR2NuM2ZhaDNYaHI3WkpHaXE1ZlJkdENpQ2s1VUFQWFR3S2czR0NKTmhaNks=`,
      },
    },
  );

export const authSMS = ({ tel, id }) =>
  client.post(
    '/user/sms',
    { tel, id },
    {
      headers: {
        Authorization: `Basic MzBjZWFjYzgtM2U4NC00ZjZiLTg0ZWUtN2JlZjdlOTI4MjBjOjNCaUdYa3dVcTNEYzhFa2NlTk14ZDgzTVJHWEFheVNXc0g0UkV4c2tSUDF3S1V2dVRhWkJwdW15YmphRXBSa3I=`,
      },
    },
  );

export const createAdministrator = ({ userId, name, tel }) =>
  client.post('/administartor', { userId, name, tel });

export const getAdministrator = () => client.get('/administartor');

export const deleteAdministrator = id =>
  client.post(`/administartor?adminId=${id}`, null, {
    headers: {
      'X-Method-Override': 'DELETE',
    },
  });

export const authEmail = ({ email, id }) =>
  client.post(
    '/user/email',
    { email, id },
    {
      headers: {
        Authorization: `Basic MzBjZWFjYzgtM2U4NC00ZjZiLTg0ZWUtN2JlZjdlOTI4MjBjOjNCaUdYa3dVcTNEYzhFa2NlTk14ZDgzTVJHWEFheVNXc0g0UkV4c2tSUDF3S1V2dVRhWkJwdW15YmphRXBSa3I=`,
      },
    },
  );

export const updatePersonalInfo = userId =>
  client.post(
    '/user/personal',
    { userId },
    {
      headers: {
        Authorization: `Basic MzBjZWFjYzgtM2U4NC00ZjZiLTg0ZWUtN2JlZjdlOTI4MjBjOjNCaUdYa3dVcTNEYzhFa2NlTk14ZDgzTVJHWEFheVNXc0g0UkV4c2tSUDF3S1V2dVRhWkJwdW15YmphRXBSa3I=`,
        'X-Method-Override': 'PATCH',
      },
    },
  );
